import { cwslapi } from "../index";

// 获取活动信息
export const getInfoApi = (data) => {
  return cwslapi({
    url: "/teamupActivity/getInfo",
    method: "post",
    data,
  });
};

// 创建队伍
export const createTeamApi = (data) => {
  return cwslapi({
    url: "/teamupActivity/createTeam",
    method: "post",
    data,
  });
};

// 加入队伍
export const joinTeamApi = (data) => {
  return cwslapi({
    url: "/teamupActivity/joinTeam",
    method: "post",
    data,
  });
};

// 领取
export const claimRewardApi = (data) => {
  return cwslapi({
    url: "/teamupActivity/claimReward",
    method: "post",
    data,
  });
};
